export default __webpack_public_path__ + "img/icons8-whatsapp.c7ded4b34cfe3b04f6dc545f9e0bcd78.svg";